import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import fp from 'lodash/fp';
import { connect } from 'react-redux';
import actions from '../../actions';
import withResetPos from '../../assist/withResetPos';
import { Cell, CellInner, CellIcon } from './CartToolBarCell';

class CartItemListToolBar extends React.PureComponent {
  static propTypes = {
    resetPos: PropTypes.func,
    openDiscountModal: PropTypes.func,
  };

  static defaultProps = {
    resetPos: _.identity,
    openDiscountModal: _.identity,
  };

  render() {
    const { resetPos, openDiscountModal } = this.props;

    return (
      <React.Fragment>
        <Cell onClick={resetPos}>
          <CellInner>
            整筆刪除
            <CellIcon prefix icon="trash-alt" />
          </CellInner>
        </Cell>
        <Cell onClick={openDiscountModal}>
          <CellInner>
            設定訂單折扣
            <CellIcon prefix icon="badge-percent" />
          </CellInner>
        </Cell>
      </React.Fragment>
    );
  }
}

const { open: openDiscountModal } = actions.discountModal;

export default fp.compose(
  withResetPos(),
  connect(
    null,
    { openDiscountModal }
  )
)(CartItemListToolBar);



// WEBPACK FOOTER //
// ./src/components/Cart/CartItemListToolBar.js